define('glu/grid/filter/amountSearch',['require','./fieldSearch','../../util','../../locale','hbs!./amountSearch.hbs','../../flexDropdown','../../templateHelpers','../../core/internal/masking'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch'),
        util = require('../../util'),
        locale = require('../../locale'),
        tmpl = require('hbs!./amountSearch.hbs'),
        FlexDropdown = require('../../flexDropdown'),
        format = require('../../templateHelpers');

    require('../../core/internal/masking');

    var operatorMap = {
        'EQ': '=',
        'LT': '<',
        'LTEQ': '<=',
        'GT': '>',
        'GTEQ': '>=',
        'BETWEEN': 'in between'
    };

    return FieldSearch.extend({
        template: tmpl,

        ui: util.extend({}, FieldSearch.prototype.ui, {
            $fieldSelect: 'select',
            $fieldOperator: 'select[name="field-equality"]',
            $fieldValue2: 'input[name="field-value2"]',
            $operandContainer: '.search-operand-container'
        }),

        regions: {
            fieldEquality: '.region-field-equality'
        },

        handleOpSelection: function(ids) {
            var operator = ids[0],
                isBetween = operator === 'BETWEEN';

            this.ui.$operandContainer.toggleClass('range-input', isBetween);
            this.ui.$fieldValue.attr('placeholder', isBetween ? 'start' : '');
        },

        onRender: function() {
            FieldSearch.prototype.onRender.call(this);
            this.showDropdown();
            this.ui.$focusField.maskAmount();
        },

        onClose: function() {
            this.ui.$focusField.unmask();
        },

        createDropdown: function() {
            var dropdown,
                data = this.getDropDownData();
            var flexDropdownOptions = {
                data: data,
                filter: false,
                multiSelect: false,
                preSelectedIds: this.model && this.model.get('equality') ? [this.model.get('equality')] : [data[0].id],
                showTooltip: false,
                showCancelIcon: false,
                clearBtn: false,
                disableMultiButton: true
            };

            dropdown = new FlexDropdown(flexDropdownOptions);

            this.listenTo(dropdown, 'selectionChanged:id', this.handleOpSelection);

            return dropdown;
        },

        getDropDownData: function() {
            return [{
                id: 'EQ',
                name: locale.get('filter.equal')
            }, {
                id: 'LT',
                name: locale.get('filter.less')
            }, {
                id: 'LTEQ',
                name: locale.get('filter.less.or.equal')
            }, {
                id: 'GT',
                name: locale.get('filter.greater')
            }, {
                id: 'GTEQ',
                name: locale.get('filter.greater.or.equal')
            }, {
                id: 'BETWEEN',
                name: locale.get('filter.between')
            }];
        },

        onBeforeRender: function() {
            this.initializeDropdown();
        },

        initializeDropdown: function() {
            if (this.dropdown) {
                this.dropdown.close();
            }
            this.dropdown = this.createDropdown();
        },

        showDropdown: function() {
            this.fieldEquality.show(this.dropdown);
        },

        templateHelpers: function() {
            var equality = this.model ? this.model.get('equality') : '';
            return {
                cid: this.cid,
                isOpBetween: equality === 'BETWEEN'
            };
        },

        handleSubmit: function(e) {
            e.preventDefault();

            if (!this.model.isValid()) {
                return false;
            }

            var equality = this.dropdown.value('id')[0],
                value = this.ui.$fieldValue.val(),
                value2 = this.ui.$fieldValue2.val();

            var filter = this.buildFilter(value, equality, value2);
            try {
                this.trigger('filter', filter);
            } catch (ex) {
                return false;
            }
            return false;
        },

        filter: function(field, value, equality, model) {
            switch (equality) {
                case 'BETWEEN':
                    return model.get(field) >= util.min(value) && model.get(field) <= util.max(value);
                case 'LT':
                    return model.get(field) < value;
                case 'LTEQ':
                    return model.get(field) <= value;
                case 'GT':
                    return model.get(field) > value;
                case 'GTEQ':
                    return model.get(field) >= value;
                default:
                    return model.get(field) === value;
            }

        },

        createFilter: function() {
            return this.buildFilter(this.ui.$focusField.get(0).value, this.dropdown.value('id')[0], this.ui.$focusField.get(1).value);
        },

        buildFilter: function(value, equality, value2) {
            var filterOutput;
            if (equality === 'BETWEEN') {
                var rangeNumericValue = [format.removeNumberFormat(value), format.removeNumberFormat(value2)];
                filterOutput = {
                    label: operatorMap[equality] + ' ' + value + ' - ' + value2, // need design for badge
                    title: this.model.get('title'),
                    value: rangeNumericValue,
                    type: 'amount',
                    field: this.field,
                    equality: equality,
                    filter: util.bind(this.filter, this, this.field, rangeNumericValue, equality)
                };
            } else {
                var numericValue = format.removeNumberFormat(value);
                filterOutput = {
                    label: operatorMap[equality] + ' ' + value,
                    title: this.model.get('title'),
                    value: numericValue,
                    type: 'amount',
                    field: this.field,
                    equality: equality || 'EQ',
                    filter: util.bind(this.filter, this, this.field, numericValue, equality)
                };
            }
            return filterOutput;
        }
    });
});

